import * as Sentry from '@sentry/react';

// Error tracking only: no tracing, no session replay (free-tier traffic).
// Without REACT_APP_SENTRY_DSN (local dev) Sentry is not initialised at all —
// captureException etc. then are silent no-ops and everything works as before.
export function initSentry() {
    const dsn = process.env.REACT_APP_SENTRY_DSN;
    if (!dsn) return;
    Sentry.init({
        dsn,
        environment: process.env.REACT_APP_SENTRY_ENV || 'development',
        sendDefaultPii: false,
    });
}

export { Sentry };
